import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CoreConfigService } from '../../../../../@core/services/config.service';
import { CoreConfig } from '../../../../../@core/types';

@Component({
    selector: 'app-auth-pages',
    templateUrl: './auth-pages.component.html',
    styleUrl: './auth-pages.component.scss',
    standalone: false
})
export class AuthPagesComponent implements OnInit, OnDestroy {

    // Public
    @Input() imageUrl: string = '';
    @Input() imageUrlAlt: string = '';
    public coreConfig: CoreConfig;
    public loading = false;
    public isForgotPasswordPage: boolean = false;

    // Private
    private _onDestroy: Subject<void> = new Subject<void>();
    logoImageUrl: string;

    constructor(
        private _coreConfigService: CoreConfigService,
        private _activatedRoute: ActivatedRoute
    ) {
        this._coreConfigService.setCconfig({
            layout: {
                navbar: {
                    hidden: true
                },
                menu: {
                    hidden: true
                },
                footer: {
                    hidden: true
                },
                customizer: false,
                enableLocalStorage: false
            }
        });
    }

    ngOnInit(): void {

        this.isForgotPasswordPage = location.hash.startsWith('#/forgot-password-v2');

        // Subscribe to config changes
        this._coreConfigService.config
            .pipe(takeUntil(this._onDestroy))
            .subscribe(config => {
                this.coreConfig = config;
                this.logoImageUrl = this.coreConfig?.app?.appLogoImage;
            });

        this._activatedRoute.data.subscribe(({ leftImage }) => {
            if (leftImage) {
                this.imageUrl = leftImage;
            }
        })
    }

    ngOnDestroy(): void {
        this._onDestroy.next();
        this._onDestroy.complete();
    }

}
